import { useState } from 'react'
import { config } from '../lib/config'
import { NavLink } from '../lib/router'
import { BrandMark } from './BrandMark'
import { PlayButton } from './PlayButton'

const links = [
  { to: '/', label: 'Home', end: true },
  { to: '/tntwars', label: 'TNTWars' },
  { to: '/leaderboard', label: 'Leaderboard' },
  { to: '/tournaments', label: 'Tornei' },
  { to: '/status', label: 'Stato servizi' },
]

export function Navbar() {
  const [open, setOpen] = useState(false)

  return (
    <header className="navbar">
      <NavLink aria-label="BlastCore home" className="brand" to="/">
        <BrandMark compact />
      </NavLink>
      <button
        aria-expanded={open}
        aria-label="Apri navigazione"
        className="nav-toggle"
        onClick={() => setOpen((value) => !value)}
        type="button"
      >
        <span />
        <span />
      </button>
      <nav className={open ? 'nav-links nav-links--open' : 'nav-links'}>
        {links.map((link) => (
          <NavLink
            className={({ isActive }) => (isActive ? 'active' : undefined)}
            end={link.end}
            key={link.to}
            onClick={() => setOpen(false)}
            to={link.to}
          >
            {link.label}
          </NavLink>
        ))}
      </nav>
      <div className="navbar__actions">
        <span className="server-ip">{config.serverIp}</span>
        <PlayButton compact />
      </div>
    </header>
  )
}
